import React from 'react';
import {
  Customer,
  CustomerContext,
  GeoLocationCoords,
  StatesListConfigContext
} from 'ui-smartforce-settings';
import {
  computeFitViewport,
  getCenterPosition,
  getLocationText,
  getZoom
} from '../helpers';
import { ProjectArea } from '../../../../../../../../Models/ProjectValue';

export interface UseProjectMapProps {
  areas?: ProjectArea[];
}

export interface UseProjectMapReturnProps {
  locationText: string;
  areasPaths: GeoLocationCoords[][] | undefined;
  position: GeoLocationCoords;
  zoom: number;
}

export const UseProjectMap = ({
  areas
}: UseProjectMapProps): UseProjectMapReturnProps => {
  const customer = React.useContext(CustomerContext).customer;
  const statesList = React.useContext(StatesListConfigContext).statesList;
  const locationText = getLocationText(customer, areas);

  let areasPaths = areas?.map((area) => {
    let fullPath = area.paths.map((p) => {
      return { latitude: p.lat, longitude: p.lng } as GeoLocationCoords;
    });

    fullPath = [...fullPath, fullPath[0]];
    return fullPath;
  });

  const fit = areasPaths ? computeFitViewport(areasPaths) : null;
  const position =
    fit?.center || getCenterPosition(statesList, customer as Customer);
  const zoom = fit?.zoom || getZoom(customer);

  return {
    locationText,
    areasPaths,
    position,
    zoom
  };
};
